jQuery(document).ready(function (e) {
  function s(customerIdentities) {
    if(customerIdentities.length <= 0) return "";
    var options = '<label>Adresse funnet</label>';
    options += '<div class="second-col woocommerce-input-wrapper">'
    if (customerIdentities.length = 1) {
      var ci = customerIdentities[0];
      options += '<input type="text" disabled="disabled" id="customers_company_address" class="input-text" value="'
      if(ci.customerType.toLowerCase() == "business") {
        options += ci.fullName + ', ';
      } else if(ci.customerType.toLowerCase() == "person") {
        options += ci.lastName + ', '
            + ci.firstName + ' ';
      }
      options += ci.street + ' '
        + ci.zipCode + ' '
        + ci.locality
        + '" />'
      options += '<input type="hidden" name="address_selector" value="' + ci.addressSelector + '" /> '
    } else {
      for (var i=0; i<customerIdentities.length; ++i) {
        var ci = customerIdentities[i];

        options += '<option class="second-col" value="' + ci.addressSelector + '">';

        if(ci.customerType.toLowerCase() == "business") {
          options += ci.fullName + ', ';
        } else if(ci.customerType.toLowerCase() == "person") {
          options += ci.lastName + ', '
              + ci.firstName + ' ';
        }

        options += ci.street + ' '
            + ci.zipCode + ' '
            + ci.locality
            + '</option>';
      }
    }

    options += '<span class="ref-description" id="" aria-hidden="false">Faktura sendes elektronisk (EHF) der dette er mulig. Postadresse benyttes kun dersom elektronisk faktura ikke kan mottas.</span>'
    options += '</div>'


    return options;
  }

  function customerCustomRef(showOrHide) {
    if (typeof showOrHide == 'undefined') {
      showOrHide = 'show'
    }
    if (showOrHide == 'hide') {
      e('.customer-custom-reference').hide('fast')
    } else {
      var firstName = e("input[name='billing_first_name']").val()
      var lastName = e("input[name='billing_last_name']").val()
      var userRole = e("input[name='user_role']").val()
      var customRef = firstName + ' ' + lastName
      if (userRole && userRole.length) {
        customRef += ' (' + userRole + ')'
      }
      if (customRef.length > 32) {
        customRef = customRef.substring(0, 29) + '...'
      }
      e("input[name='customer_custom_reference']").val(customRef)
      e('.customer-custom-reference').css('display', 'flex')
      var refDesc = e('#customer_custom_reference-description')
      if (!refDesc.length) {
        e('.customer-custom-reference').find('.woocommerce-input-wrapper').append('<span class="ref-description" id="customer_custom_reference-description" aria-hidden="false">NB: Dette feltet er viktig for din regnskapsavdeling. Få med korrekt informasjon som for eksempel kostnadssted. Maksimalt 32 tegn.</span>')
      }
    }
  }

  function emailInvoiceReciever(showOrHide) {
    if (typeof showOrHide == 'undefined') {
      showOrHide = 'show'
    }
    if (showOrHide == 'hide') {
      e('.company-invoicing-email').hide('fast')
    } else {
      e('.company-invoicing-email').css('display', 'flex')
      var refDesc = e('#email_invoice_reciever-description')
      if (!refDesc.length) {
        e('.company-invoicing-email').find('.woocommerce-input-wrapper').append('<span class="ref-description" id="email_invoice_reciever-description" aria-hidden="false">Vennligst benytt e-postadresse til din organisasjons fakturamottak.</span>')
      }
    }
  }

  function loaderHtml() {
    return '<div class="fk-loading-ellipsis"><div></div><div></div><div></div><div></div></div>';
  }

  function showErrMsg(msg) {
    e('[name="woocommerce_checkout_place_order"]').attr('disabled', 'disabled')
    return e(".svea-messages-container").addClass('error-message'),
      e(".svea-messages-container").show('fast'),
      e(".svea-messages-container").find('.second-col').html(msg)
  }

  function hideErrMsg() {
    return e(".svea-messages-container").hide('fast'),
      e(".svea-messages-container").removeClass('error-message'),
      e(".svea-messages-container").find('.second-col').html('')
  }

  function searchForAddress(t) {
    if (e('#iv_billing_org_number').val().length != 9) {
      return
    }
    var n = g
    var orgNoContainer = e('.organisation-number-container')
    var messageParent = e(".svea-messages-container")
    var messageContainer = e(".svea-messages-container").find('.second-col')

    var i = (e(this), e(this).closest(".svea-get-address-button-container")),

      d = e(".svea-get-address-button-container.get-address-shortcode").is(":visible");

    orgNoContainer.find('.svea-message.error').remove()

    if (!l)
      if (d && (n = c.INVOICE), "individual" == _ || n == c.PART_PAY) {
        var v;
        if (d) v = e("[name='svea_billing_ssn']").val();
        else {
          var u;
          u = n == c.INVOICE ? "iv" : "pp", v = e("[name='" + u + "_billing_ssn']").val()
        }
        i.addClass("getting-address"),

        l = !0, e.post(Svea.ajaxUrl, {
          action: "svea_get_address",
          pers_nr: v,
          country_code: m,
          payment_type: n,
          security: Svea.gaSecurity
        }, function (e) {
          if (i.removeClass("getting-address"), l = !1, "undefined" == typeof e.resultcode || "undefined" == typeof e.customerIdentity) return i.append('<div class="svea-message error">' + Phrases.could_not_get_address + "</div>"), i.addClass("getting-address-error"), void setTimeout(function () {
            i.find(".svea-message.error").remove(), i.removeClass("getting-address-error")
          }, 5e3);
          if ("Error" == e.resultcode || "NoSuchEntity" == e.resultcode) return i.append('<div class="svea-message error">' + e.errormessage + "</div>"), i.addClass("getting-address-error"), void setTimeout(function () {
            i.find(".svea-message.error").remove(), i.removeClass("getting-address-error")
          }, 5e3);
          var s = e.customerIdentity[0];
          a(s), i.append('<div class="svea-message success">' + Phrases.your_address_was_found + "</div>"), i.addClass("getting-address-success"), setTimeout(function () {
            i.find(".svea-message.success").remove(), i.removeClass("getting-address-success")
          }, 5e3)
        })
      } else if ("company" == _) {
        var p;
        if (d) p = e("[name='svea_billing_org_number']").val();
        else {
          var u;
          u = n == c.INVOICE ? "iv" : "pp", p = e("[name='" + u + "_billing_org_number']").val()
        }

        l = !0,
        // SHow message that fetching address
        messageParent.show('fast')
        messageContainer.html('Henter adresse, venligst vent ' + loaderHtml())
        // Hide prev address selector
        customerCustomRef('hide')
        emailInvoiceReciever('hide')
        e(".org-address-selector").parent().removeClass('display-the-row')
        e(".org-address-selector").html('')

        e.post(Svea.ajaxUrl, {
          action: "svea_get_address",
          org_nr: p,
          country_code: m,
          payment_type: n,
          security: Svea.gaSecurity
        }, function (t) {
            console.log(t)
          if (l = !1, "undefined" == typeof t.resultcode || "undefined" == typeof t.customerIdentity) {
            return showErrMsg(Phrases.could_not_get_address),
            void setTimeout(function () {
              return hideErrMsg()
            }, 10e3);
          } else if ("NoSuchEntity" == t.resultcode) {
            return showErrMsg('Ingen kunde adresse ble funnet.'),
            void setTimeout(function () {
              return hideErrMsg()
            }, 10e3);
          } else if ("Error" == t.resultcode && t.errormessage.indexOf('SecurityNumber - company (NO) invalid') > -1) {
            return showErrMsg('Ugyldig organisasjonsnummer.'),
              void setTimeout(function () {
              return hideErrMsg()
            }, 10e3);
          } else if ("Error" == t.resultcode) {
            return showErrMsg('Det oppsto en feil ved henting av organisasjonsnummeret ditt. Vennligst prøv igjen senere.'),
              void setTimeout(function () {
                return hideErrMsg()
              }, 10e3);
          } else if ("Accepted" != t.resultcode) {
            return showErrMsg(t.errormessage),
              void setTimeout(function () {
              return hideErrMsg()
            }, 10e3);
          }
          messageParent.hide('fast')
          messageContainer.html('')
          var n = t.customerIdentity;
          if (!t.ehf_enabled) {
            emailInvoiceReciever()
          }
            e(".org-address-selector").parent().addClass('display-the-row'),
            e(".org-address-selector").html(s(n)),
              customerCustomRef(),
              r = n,
              e(".address-selector").val(n[0].addressSelector),
              a(n[0]),
              o = n[0],
              i.addClass("getting-address-success"),
              i.append('<div class="svea-message success">' + Phrases.your_address_was_found + "</div>"),
              e('[name="woocommerce_checkout_place_order"]').removeAttr('disabled')
              setTimeout(function () {
                i.find(".svea-message.success").remove(), i.removeClass("getting-address-success")
              }, 10e3)
        })
      }
  }

  function a(s) { }

  function t(s) {
    s ? (e("#billing_address_1, #billing_address_2, #billing_postcode, \t\t\t\t#billing_city").prop("readonly", !1), e("#billing_address_1, #billing_address_2, #billing_postcode, \t\t\t\t#billing_city").removeClass("disabled-input")) : (e("#billing_address_1, #billing_address_2, \t\t\t\t#billing_postcode, #billing_city").prop("readonly", !0), e("#billing_address_1, #billing_address_2, \t\t\t\t#billing_postcode, #billing_city").addClass("disabled-input"))
  }

  function n(e, s, a) {
    switch (e) {
      case "SE":
      case "DK":
        switch (s) {
          case c.INVOICE:
          case c.PART_PAY:
            if ("individual" === a) return !1
        }
    }
    return !0
  }

  function t(s) {
    s ? (e("#billing_first_name, #billing_last_name, #billing_address_1, \t\t\t\t#billing_address_2, #billing_postcode, #billing_city").prop("readonly", !1), e("#billing_first_name, #billing_last_name, #billing_address_1, \t\t\t\t#billing_address_2, #billing_postcode, #billing_city").removeClass("disabled-input")) : (e("#billing_first_name, #billing_last_name, #billing_address_1, \t\t\t\t#billing_address_2, #billing_postcode, #billing_city").prop("readonly", !0), e("#billing_first_name, #billing_last_name, #billing_address_1, \t\t\t\t#billing_address_2, #billing_postcode, #billing_city").addClass("disabled-input"))
  }

  function i() {
    e("#billing_first_name, #billing_last_name, #billing_address_1, \t\t\t\t#billing_address_2, #billing_postcode, #billing_city").val([])
  }
  String.prototype.clone = function () {
    return JSON.parse(JSON.stringify(this))
  };
  var r = [],
    o = !1,
    d = !1,
    l = !1,
    c = {
      INVOICE: "sveawebpay_invoice",
      PART_PAY: "sveawebpay_part_pay",
      CARD: "sveawebpay_card",
      DIRECT_BANK: "sveawebpay_direct_bank"
    },
    g = e('[name="payment_method"]:checked').val() || !1,
    m = e('[name="billing_country"]').val() || !1;
  if ("undefined" != typeof Svea.sameShippingAsBilling[g] && Svea.sameShippingAsBilling[g] && e(".woocommerce form.woocommerce-checkout").addClass("hide-shipping-fields"), 0 != Svea.onlyOneAllowedCountry && (m = Svea.onlyOneAllowedCountry), Svea.isPayPage) {
    m = Svea.customerCountry;
    e(".payment_methods, .svea-get-address-button-container").addClass("is-pay-page")
  }
  e(".payment_methods, .svea-get-address-button-container").addClass("payment-method-" + g).addClass("country-" + (m ? m.toLowerCase() : "false"));
  var _ = !1;
  e(".svea-get-address-button-container.get-address-shortcode").length > 0 && (e(".payment_method_" + c.INVOICE).is(":visible") ? e(".svea-get-address-button-container.get-address-shortcode").removeClass("invoice-not-available") : e(".svea-get-address-button-container.get-address-shortcode").addClass("invoice-not-available")), e(".svea-get-address-button-container.get-address-shortcode").is(":visible") && (_ = e("[name='svea_get_address_customer_type']:checked").val(), e('[name="iv_billing_customer_type"]').val(_), e(".payment_methods, .svea-get-address-button-container").addClass("customer-type-" + _)), n(m, g, _) ? n(m, g, _) && t(!0) : (t(!1), d || i()), e(document).on("change", ".woocommerce form.woocommerce-checkout .woocommerce-billing-fields :input", function (e) {
    d = !1
  }), e(document).on("change", '[name="svea_billing_ssn"]', function (s) {
    e("[name='iv_billing_ssn'], [name='pp_billing_ssn']").val(e(this).val())
  }),

  e(document).on("click", ".svea-get-address-button", function (t) {
    t.preventDefault();
    e(document).trigger('orgNumberModalTriger')
    return
  }),


  e(document).on('searchForAddress', searchForAddress),
  e(document).on('keyup', '#iv_billing_org_number', searchForAddress),
  e(document).on('keyup', '[name="iv_billing_ssn"]', function (s) {
    s.preventDefault()
    if (e('[name="iv_billing_ssn"]').val().length == 11) {
      e('[name="woocommerce_checkout_place_order"]').prop('disabled', false)
    } else {
      e('[name="woocommerce_checkout_place_order"]').prop('disabled', true)
    }
  }),



  Svea.isPayPage && e('.payment_methods [name="payment_method"]').on("change", function () {
    var s = g || !1;
    g = e('[name="payment_method"]:checked').val(), _ = e('[name="iv_billing_customer_type"]').val() || !1, e(".payment_methods, .svea-get-address-button-container").removeClass("payment-method-" + s).addClass("payment-method-" + g).removeClass("customer-type-" + _).addClass("customer-type-" + _), o = !1, r = [], e(".org-address-selector").html("")
  }), e(document).on("updated_checkout", function () {
    e(".svea-get-address-button-container.get-address-shortcode").length > 0 && (e(".payment_method_" + c.INVOICE).is(":visible") ? e(".svea-get-address-button-container.get-address-shortcode").removeClass("invoice-not-available") : e(".svea-get-address-button-container.get-address-shortcode").addClass("invoice-not-available")), e(".svea-get-address-button-container.get-address-shortcode").is(":visible") && (e("[name='iv_billing_ssn'], [name='pp_billing_ssn']").val(e("[name='svea_billing_ssn']").val()),
      e('[name="iv_billing_customer_type"]').val(e('[name="svea_get_address_customer_type"]:checked').val()));
    var a = m || !1,
      l = g || !1,
      v = _ || !1;
    0 == Svea.onlyOneAllowedCountry && (m = e('[name="billing_country"]').val()), g = e('[name="payment_method"]:checked').val(), _ = e('[name="iv_billing_customer_type"]').val() || !1, e(".payment_methods, .svea-get-address-button-container").removeClass("country-" + (a ? a.toLowerCase() : "false")).addClass("country-" + (m ? m.toLowerCase() : "false")).removeClass("payment-method-" + l).addClass("payment-method-" + g), e(".svea-get-address-button-container.get-address-shortcode").is(":visible") && (_ = e('[name="iv_billing_customer_type"]').val() || !1), e(".payment_methods, .svea-get-address-button-container").removeClass("customer-type-" + v).addClass("customer-type-" + _), o !== !1 && r.length > 0 && (e(".org-address-selector").html(s(r)), e(".org-address-selector").val(o.addressSelector), customerCustomRef(), e(".address-selector").val(o.addressSelector)), "undefined" != typeof Svea.sameShippingAsBilling[g] && Svea.sameShippingAsBilling[g] ? e(".woocommerce .woocommerce-checkout").hasClass("hide-shipping-fields") || e(".woocommerce .woocommerce-checkout").addClass("hide-shipping-fields") : e(".woocommerce .woocommerce-checkout").hasClass("hide-shipping-fields") && e(".woocommerce .woocommerce-checkout").removeClass("hide-shipping-fields"), a === m && g === l || (o = !1, r = [], e(".org-address-selector").html(""), n(m, g, _) ? n(m, g, _) && t(!0) : (t(!1), d || i()))
  }), e(document).on("change", '[name="payment_method"]', function () {
    e("body").trigger("update_checkout")
  }), e(document).on("change", '[name="billing_country"]', function () {
    var s = m || !1;
    m = e('[name="billing_country"]').val(), e(".payment_methods, .svea-get-address-button-container").removeClass("country-" + (s ? s.toLowerCase() : "false")).addClass("country-" + (m ? m.toLowerCase() : "false")), n(m, g, _) ? n(m, g, _) && t(!0) : (t(!1), d || i())
  });
  var v = null;
  e(document).on("change", '[name="iv_billing_customer_type"], [name="svea_get_address_customer_type"]', function () {
    e('.org-address-selector-container').removeClass('display-the-row').find('.org-address-selector').html(''), customerCustomRef('hide')
    if (l) return void (null != v && e(this).val(v.val()));
    var s = _ || !1;
    _ = e(this).val() || !1, e(".payment_methods, .svea-get-address-button-container").removeClass("customer-type-" + s).addClass("customer-type-" + _), v = e(this), n(m, g, _) ? n(m, g, _) && t(!0) : (t(!1), d || i())
  }), e(document).on("change", '[name="svea_get_address_customer_type"]', function () {
    e("[name='iv_billing_customer_type']").val(e(this).val()), v = e(this), e("body").trigger("update_checkout")
  }), e(document).on("change", ".org-address-selector", function () {
    for (var s = 0; s < r.length; ++s) {
      var t = r[s];
      if (t.addressSelector == e(".org-address-selector").val()) return e(".address-selector").val(e(".org-address-selector").val()), a(t), void (o = t)
    }
  }), e(document).on("change", ".birth-date-month, .birth-date-day, .birth-date-year", function () {
    var s = e(this).parents(".svea-part-pay-fields, .svea-invoice-fields"),
      a = parseInt(s.find(".birth-date-year").val()),
      t = parseInt(s.find(".birth-date-month").val()),
      n = parseInt(s.find(".birth-date-day").val()),
      i = new Date(a, t, 0),
      r = i.getDate();
    s.find(".birth-date-day option").each(function () {
      parseInt(e(this).val()) > r ? e(this).prop("disabled", !0) : e(this).prop("disabled", !1)
    }), n > r && s.find(".birth-date-day").val(r)
  })
});
